import { render, staticRenderFns } from "./heat-map.vue?vue&type=template&id=164f5ecc&scoped=true&"
import script from "./heat-map.vue?vue&type=script&lang=ts&"
export * from "./heat-map.vue?vue&type=script&lang=ts&"
import style0 from "./heat-map.vue?vue&type=style&index=0&id=164f5ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f5ecc",
  null
  
)

export default component.exports